module.exports = __webpack_public_path__ + "img/503.f076f8be.jpg";